// extracted by mini-css-extract-plugin
export default {"container":"style_container__77fTn","homy_area":"style_homy_area__tuWfC","ulmarg":"style_ulmarg__1OE6R"};